<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/edit_log/custom/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('zuijintiaoshuchaxun')" name="first"></el-tab-pane>
          <el-tab-pane :label="$t('shijianqujianchaxun')" name="second"></el-tab-pane>
        </el-tabs>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <div v-show="activeName === 'first'">
            <el-form-item :label="$t('zuijinjilutiaoshu')">
              <el-select v-model="yt.conditions.maxSize" :placeholder="$t('qingxuanze')" clearable>
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')">
              <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"></yi_data_select>
            </el-form-item>
            <el-form-item>
              <el-button @click="yt.get(1)" type="primary" plain="plain">
                {{ $t('sousuo') }}
              </el-button>
              <el-button @click="clear()">{{ $t('chongzhi') }}</el-button>
              <yi_curd_expand_button></yi_curd_expand_button>
            </el-form-item>
          </div>
          <div v-show="activeName === 'second'">
            <el-form-item :label="$t('fashengshijian')">
              <!-- 时间跨度最大七天 -->
              <yi_time_input :maxTime="7 * 24 * 3600 * 1000" type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')">
              <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"></yi_data_select>
            </el-form-item>
            <el-form-item>
              <el-button @click="yt.get(1)" type="primary" plain="plain">
                {{ $t('sousuo') }}
              </el-button>
              <el-button @click="clear()">{{ $t('chongzhi') }}</el-button>
              <yi_curd_expand_button></yi_curd_expand_button>
            </el-form-item>
          </div>
        </el-form>
      </template>
      <template #gongyicanshu="scope">
        {{ getParam(scope.row) }}
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_process_management_records_list',
  data() {
    return {
      activeName: 'first',
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'name'
          // type: 'dictionary',
          // key: 'PARAMETER_TYPE',
          // width: 130
        },
        {
          type: 'slot',
          label: 'gongyicanshu',
          prop: 'parameter',
          width: 130
        },
        {
          label: 'xiugaiqian',
          prop: 'beforeChange'
        },
        {
          label: 'xiugaihou',
          prop: 'afterChange'
        },
        {
          label: 'fashengshijian',
          prop: 'happenDatetime',
          type: 'time'
        }
      ],
      options: [
        {
          value: 10,
          label: '10'
        },
        {
          value: 20,
          label: '20'
        },
        {
          value: 30,
          label: '30'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      if (this.activeName === 'first') {
        this.yt.conditions = {
          equipmentId: this.store.state.eqs[0]['id'],
          maxSize: 10
        }
      }
      this.yt.get(1);
      this.yt.list = [];
      // this.yt.get(1, this.beforeGet)
    }, 300);
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "first") {
        this.yt.conditions = {
          equipmentId: this.store.state.eqs[0]['id'],
          maxSize: 10
        }
      }
      if (tab.name == "second") {
        this.yt.conditions = {
          equipmentId: this.store.state.eqs[0]['id'],
        }
        this.$set(this.yt.conditions, 'startTime', this.begin());
        this.$set(this.yt.conditions, 'endTime', this.end());
      }
      this.yt.get(1);
    },
    getParam(row) {
      const param = row.parameter;
      const equipmentId = row.equipmentId;
      if (param === '' || param === undefined) {
        return '';
      }
      if (equipmentId === '' || equipmentId === undefined) {
        return param;
      }
      const data = this.store.state.eqPoints[equipmentId];
      if (data === undefined) {
        return param;
      }
      console.log('bbbbb', data)

      const res = data[param];
      if (res === undefined) {
        return param;
      }
      if (res['unit'] === undefined) {
        return this.$t(res['alias']);
      } else {
        return this.$t(res['alias']) + '(' + this.$t(res['unit']) + ')';
      }

      // return res['alias'].trim() +"("+ res['unit'].trim()+")"
    },
    // beforeGet() {
    //   // if (!this.yt.conditions.startTime || !this.yt.conditions.endTime) {
    //   //   this.$message.error(this.$t('fashengshijianbitian'));
    //   //   return;
    //   // }
    //   // if (!this.yt.conditions.equipmentId) {
    //   //   this.$message.error(this.$t('shebeimingchengbitian'));
    //   //   return;
    //   // }
    //   this.yt.get(1);
    // },
    clear() {
      this.yt.conditions = {
        startTime: this.begin(),
        endTime: this.end(),
        equipmentId: this.store.state.eqs[0]['id'],
        maxSize: 10
      };
      this.yt.list = [];
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()).getTime();
      return end;
    }
  }
};
</script>
